import { render, staticRenderFns } from "./GateEntry.vue?vue&type=template&id=06550887&scoped=true"
import script from "./GateEntry.vue?vue&type=script&lang=js"
export * from "./GateEntry.vue?vue&type=script&lang=js"
import style0 from "./GateEntry.vue?vue&type=style&index=0&id=06550887&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06550887",
  null
  
)

export default component.exports